import { IStep, IThread } from '@chainlit/react-client';

/**
 * Extracts document names from thread message history
 * Looks through all steps and nested steps for documentUpload metadata
 */
export const extractDocumentNamesFromThread = (thread: IThread | undefined): string[] => {
  if (!thread?.steps) return [];
  
  const documentNames: string[] = [];
  
  // Recursively look through all messages/steps for documentUpload metadata
  const findDocuments = (steps: IStep[]): void => {
    steps.forEach(step => {
      if (step.metadata?.documentUpload?.fileName) {
        const fileName = step.metadata.documentUpload.fileName;
        if (!documentNames.includes(fileName)) {
          documentNames.push(fileName);
        }
      }
      // Recursively check nested steps
      if (step.steps) {
        findDocuments(step.steps);
      }
    });
  };
  
  findDocuments(thread.steps);
  return documentNames;
};

/**
 * Checks if document context is enabled from thread metadata
 */
export const isDocumentContextEnabledFromThread = (thread: IThread | undefined): boolean => {
  return !!(thread?.metadata?.documentContextEnabled === true);
};

/**
 * Gets document context information from a thread
 * Returns both the enabled state and document names
 */
export const getThreadDocumentContext = (thread: IThread | undefined) => {
  return {
    enabled: isDocumentContextEnabledFromThread(thread),
    documentNames: extractDocumentNamesFromThread(thread)
  };
};